import React, { useState } from 'react';
import { Form, Button, Segment, Popup } from 'semantic-ui-react';
import config from '../config';
import { login } from 'src/api';

function OnPremLoginForm() {
  const [showCreateAccount, setShowCreateAccount] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const handleOnPremLogin = async () => {
    try {
      const response = await fetch(`${config.apiURL}/onprem/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
        credentials: 'include',
      });
      if (response.status !== 200) {
        const result = await response.json();
        setError(result?.detail || 'An error occurred while logging in');
        return;
      }
      login().catch((err) => {
        setLoginError('An error occurred while logging in');
      });
    } catch (error) {
      console.error(error);
      setError('Login error');
    }
  };

  const passwordWarning =
    password.length > 0 && password.length < 8
      ? 'Password must be at least 8 characters.'
      : null;

  const confirmPasswordWarning =
    password && confirmPassword && password !== confirmPassword
      ? 'Passwords do not match.'
      : null;

  const createAccountValid =
    email &&
    firstName &&
    lastName &&
    password.length >= 8 &&
    password === confirmPassword;

  const handleCreateAccount = async () => {
    try {
      const response = await fetch(`${config.apiURL}/onprem/createaccount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, firstName, lastName, password }),
      });
      const result = await response.json();
      if (response.status === 200) {
        setShowCreateAccount(false);
        setError('');
      } else {
        setError(result?.detail || 'Account creation failed');
      }
    } catch (error) {
      setError('Account creation failed');
    }
  };

  return (
    <>
      {error && (
        <Segment inverted color="red">
          {error}
        </Segment>
      )}

      {showCreateAccount ? (
        <Form>
          <Form.Input
            required
            label={{
              children: 'Email',
              className: 'onprem-form-input',
              name: 'username',
            }}
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Popup
            content={passwordWarning}
            open={!!passwordWarning}
            position="right center"
            style={{ color: '#9f3a38' }}
            trigger={
              <Form.Input
                required
                label={{
                  children: 'Password',
                  className: 'onprem-form-input',
                  name: 'password',
                }}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            }
          />
          <Popup
            content={confirmPasswordWarning}
            open={!!confirmPasswordWarning}
            position="right center"
            style={{ color: '#9f3a38' }}
            trigger={
              <Form.Input
                required
                label={{
                  children: 'Confirm Password',
                  className: 'onprem-form-input',
                  name: 'confirmPassword',
                }}
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            }
          />
          <Form.Input
            required
            label={{
              children: 'First Name',
              className: 'onprem-form-input',
              name: 'firstName',
            }}
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <Form.Input
            required
            label={{
              children: 'Last Name',
              className: 'onprem-form-input',
              name: 'lastName',
            }}
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <Button
            primary
            onClick={handleCreateAccount}
            disabled={!createAccountValid}
          >
            Create Account
          </Button>
          <a
            href="#"
            style={{ marginLeft: '10px' }}
            onClick={(e) => {
              e.preventDefault();
              setError('');
              setShowCreateAccount(false);
            }}
          >
            Back to Sign In
          </a>
        </Form>
      ) : (
        <Form>
          <Form.Input
            required
            label={{ children: 'Email', className: 'onprem-form-input' }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Form.Input
            required
            label={{ children: 'Password', className: 'onprem-form-input' }}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            primary
            onClick={handleOnPremLogin}
            disabled={!email || !password}
          >
            Sign In
          </Button>
          <a
            href="#"
            style={{ marginLeft: '10px' }}
            onClick={(e) => {
              e.preventDefault();
              setShowCreateAccount(true);
            }}
          >
            Create Account
          </a>
        </Form>
      )}
    </>
  );
}

export default OnPremLoginForm;
